<script setup lang="ts">
import { computed } from 'vue';
import { deviceKind, type DeviceKind } from '../utils/clickLogUi';

const props = defineProps<{
  deviceType?: string | null;
  isBot?: boolean;
}>();

const kind = computed<DeviceKind>(() => deviceKind(props.deviceType, props.isBot));

const title = computed(() => {
  switch (kind.value) {
    case 'desktop':
      return 'Desktop';
    case 'mobile':
      return 'Mobile';
    case 'tablet':
      return 'Tablet';
    case 'bot':
      return 'Bot';
    case 'tv':
      return 'TV';
    default:
      return 'Unknown';
  }
});
</script>

<template>
  <span class="device-icon" :class="`device-icon--${kind}`" :title="title" aria-hidden="true">
    <!-- desktop -->
    <svg v-if="kind === 'desktop'" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.75">
      <rect x="3" y="4" width="18" height="12" rx="1.5" />
      <path d="M8 20h8M12 16v4" stroke-linecap="round" />
    </svg>
    <!-- mobile -->
    <svg v-else-if="kind === 'mobile'" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.75">
      <rect x="7" y="2.5" width="10" height="19" rx="2" />
      <circle cx="12" cy="17.5" r="0.9" fill="currentColor" stroke="none" />
    </svg>
    <!-- tablet -->
    <svg v-else-if="kind === 'tablet'" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.75">
      <rect x="4" y="3" width="16" height="18" rx="2" />
      <circle cx="12" cy="17.5" r="0.9" fill="currentColor" stroke="none" />
    </svg>
    <!-- tv -->
    <svg v-else-if="kind === 'tv'" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.75">
      <rect x="2.5" y="5" width="19" height="12" rx="1.5" />
      <path d="M8 20h8" stroke-linecap="round" />
    </svg>
    <!-- bot -->
    <svg v-else-if="kind === 'bot'" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.75">
      <rect x="5" y="8" width="14" height="10" rx="2" />
      <circle cx="9.5" cy="13" r="1.1" fill="currentColor" stroke="none" />
      <circle cx="14.5" cy="13" r="1.1" fill="currentColor" stroke="none" />
      <path d="M12 4v4M8 18v2M16 18v2" stroke-linecap="round" />
    </svg>
    <!-- unknown -->
    <svg v-else viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.75">
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 11v5M12 8.2v.2" stroke-linecap="round" />
    </svg>
  </span>
</template>

<style scoped>
.device-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  color: var(--botto-color-text-muted, #5a6478);
  line-height: 0;
}

.device-icon--bot {
  color: var(--botto-color-primary, #24aded);
}
</style>
